import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { LocalStorage } from 'ngx-webstorage';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { User } from 'projects/core/src/lib/login/data/user';
import { KanbanBoardStore } from '../../data/kanban-board.store';

@Component({
    selector: 'app-kanban-tools',
    templateUrl: './kanban-tools.component.html',
    styleUrls: ['./kanban-tools.component.scss']
})
export class KanbanToolsComponent implements OnInit {

    @Output()
    createProject = new EventEmitter<Project>();

    loadingSpinner: boolean;


    constructor(
        protected projectService: ProjectService,
        protected kanbanBoardStore: KanbanBoardStore
    ) { }

    ngOnInit(): void {
    }

    createNewProject() {
        this.loadingSpinner = true;
        this.projectService.createProject()
            .subscribe(newProject => {
                this.loadingSpinner = false;
                this.kanbanBoardStore.newProject(newProject);
            }, error => {
                this.loadingSpinner = false;
            })
    }

}
